import request from "@/router/axios";

export const getYardSpaceBoard = (data) => {
  return request({
    url: "/api/produce/store-sub/yard-space-board",
    method: "post",
    data,
  });
};
